import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import Select from 'components/lib/Select';

import { useEditBatchShopRequestsModalContext } from './EditBatchShopRequestsModalContext';
import { SHOP_REQUEST_STATUS, SHOP_REQUEST_STATUS_LABELS } from '../constants';

const StyledSelect = styled(Select)`
  width: 407px;
  margin-right: 30px;
  &&&.ant-select {
    height: 36px;
  }

  &&& .ant-select-selector {
    border-radius: 0;
  }

  .ant-select-selection-item {
    font-size: 14px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Label = styled(Typography.Text)`
  font-family: var(--font-bold);
  margin-right: 10px;
`;

const EditBatchShopRequestsModalStatus = () => {
  const { batchShopRequests, setBatchShopRequests } = useEditBatchShopRequestsModalContext();

  return (
    <Container>
      <Label>Status</Label>
      <StyledSelect
        options={SHOP_REQUEST_STATUS.filter((item) => item.id != SHOP_REQUEST_STATUS_LABELS.APPROVED).map((item) => ({
          label: item.label,
          value: item.id,
        }))}
        value={batchShopRequests.status}
        onChange={(status: number) => {
          setBatchShopRequests({ ...batchShopRequests, status });
        }}
      />
    </Container>
  );
};

export default EditBatchShopRequestsModalStatus;
